// eslint-disable-next-line import/order
import React from 'react';

// import './App.css';
import './styles/main.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
/* import Main from "./pages/main";
import Login from "./pages/login";
import SignUp from "./pages/signup";



import Price from "./screens/Price.screen";
import Themes from "./screens/Themes.screen"; */

import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import Navigator from './navigation/Navigator';
import { store, persistor } from './store/Store';

//import Home from "./screens/Home.screen";

function App() {
	return (
		<>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<Navigator />
				</PersistGate>
			</Provider>
		</>
	);
}

export default App;
